import React, { memo } from 'react';
import { useSelector } from 'react-redux';

import PlayerOfTheGame from '../PlayerOfTheGame';
import getPlayerOfTheGameState from '../store/selectors/getPlayerOfTheGameState';
import ErrorBoundaryWrapper from '../../ErrorFallback/ErrorBoundaryWrapper';
import initContainerData from 'bdata-react-component/lib/store/initContainerData';
import potgWinnersDatasource from '@gameday/core/datasources/potgWinners';
import potgWinnersDataRequestAction from '../store/actions/potgWinnersDataRequestAction';
import potgWinnersReducer from '../store/reducers/potgWinners';
import playerStoryDataSource from '@gameday/core/datasources/playerStory';
const fetchData = () => {
    return potgWinnersDataRequestAction();
};

initContainerData.register({
    datasources: {
        potgWinners: potgWinnersDatasource,
        playerStory: playerStoryDataSource
    },
    reducers: {
        potgWinners: potgWinnersReducer
    }
});

const routes = [{
    path: '/',
    exact: false,
    fetchData
}];

const PlayerOfTheGameDataContainer = (props) => {
    const {
        showPOTG,
        deviceInteraction,
        voteLink,
        leaderboardLink,
        language,
        winnersConfig,
        blockLoginActivities
    } = useSelector(getPlayerOfTheGameState);

    if (!showPOTG) {
        return null;
    }

    return (
        <ErrorBoundaryWrapper componentName={'Player of The Game'}>
            <PlayerOfTheGame
                {...props}
                deviceInteraction={deviceInteraction}
                voteLink={voteLink}
                leaderboardLink={leaderboardLink}
                language={language}
                winnersConfig={winnersConfig}
                displayVote= {!blockLoginActivities}
            />
        </ErrorBoundaryWrapper>
    );
};

export default memo(PlayerOfTheGameDataContainer);

export { fetchData, routes };
